import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { AuthenticationService, IdbAuthStoreService, UserRolesProviderService } from '@damofire/data-security';
import { DivisionGuardService } from '@damofire/data-stas';
import { UixCommonsModule } from '@damofire/uix-commons';
import { TranslateModule } from '@ngx-translate/core';
import { AppAuthService } from './app-auth.service';
import { AuthComponent } from './auth/auth.component';
import { ForceUpdateComponent } from './force-update/force-update.component';

const SECURITY_COMPONENTS = [AuthComponent, ForceUpdateComponent];

@NgModule({
  imports: [CommonModule, TranslateModule, UixCommonsModule, ...SECURITY_COMPONENTS],
  exports: [...SECURITY_COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: UserRolesProviderService, useExisting: AppAuthService },
    { provide: AuthenticationService, useExisting: AppAuthService },
    { provide: DivisionGuardService, useExisting: AppAuthService },
    IdbAuthStoreService,
  ],
})
export class SecurityModule {
  static forRoot(): ModuleWithProviders<SecurityModule> {
    return {
      ngModule: SecurityModule,
      providers: [AppAuthService],
    };
  }
}
